// eslint-disable-next-line import/no-anonymous-default-export
export default {
  api: {
    url: "http://localhost:5000/api/v1/",
    baseUrl:"http://localhost:5000"
  },
  env: "development",
  log: "debug",
};
